import type { EnumLiteral } from '../../uiModels/enumLiterals/types'
import { EnumAddLiteralPlaceholderNameCell } from './EnumAddLiteralPlaceholderNameCell'
import type { AddLiteralPlaceholder } from './types'

type Props = {
  data: EnumLiteral | typeof AddLiteralPlaceholder
  column: number
  row?: number
}

export const EnumAddLiteralPlaceholderRowCell = ({ column }: Props) => {
  if (column === 0) {
    return <EnumAddLiteralPlaceholderNameCell />
  }
  throw new Error('Unsupported column for the literal placeholder cell.')
}
